import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../store/hooks";
import { isAdminApiEnabled } from "../config/adminApiFeature";
import { isAdminAuthenticated } from "../utils/adminSession";

/** Must match `public/index.html` `<title>` */
export const ADMIN_SITE_DOCUMENT_TITLE = "Vizhacks: Technology Consulting";

/**
 * Facebook-style tab title when signed in as admin: `(3) Vizhacks: …` when inbox unread &gt; 0.
 * Runs app-wide (public routes too) so the tab updates while browsing the site.
 * Uses the same count as the admin top bar (`dashboard.data.unread.total`).
 */
export function useAdminUnreadDocumentTitle() {
  useLocation();
  const apiOn = isAdminApiEnabled();
  const authed = isAdminAuthenticated();
  const unreadTotal = useAppSelector((s) =>
    apiOn && authed ? (s.dashboard.data?.unread?.total ?? 0) : 0
  );

  useEffect(() => {
    if (!apiOn || !authed) {
      document.title = ADMIN_SITE_DOCUMENT_TITLE;
      return;
    }
    if (unreadTotal > 0) {
      const label = unreadTotal > 99 ? "99+" : String(unreadTotal);
      document.title = `(${label}) ${ADMIN_SITE_DOCUMENT_TITLE}`;
    } else {
      document.title = ADMIN_SITE_DOCUMENT_TITLE;
    }
  }, [apiOn, authed, unreadTotal]);

  useEffect(() => {
    return () => {
      document.title = ADMIN_SITE_DOCUMENT_TITLE;
    };
  }, []);
}
